module.exports = __webpack_public_path__ + "img/anu_anubistokens.ef5c354.png";